module.exports = __webpack_public_path__ + "resources/heart-0b59aafcdbe9df3e394e8438d113b91b.png";